module.exports = __webpack_public_path__ + "img/logo-full.4e0920d2.svg";